import { render, staticRenderFns } from "./FlipbookContent.vue?vue&type=template&id=2dc2328e&"
import script from "./FlipbookContent.vue?vue&type=script&lang=js&"
export * from "./FlipbookContent.vue?vue&type=script&lang=js&"
import style0 from "./FlipbookContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports